<template>
  <RouterLink :to="{ name: 'import' }" class="btn btn-primary d-flex align-items-center justify-content-center">
    <div class="atom-icon">
      <img src="@/assets/icons/actions/ico-btn-nova.svg" />
    </div>
    {{ $t("importZarizeni") }}
  </RouterLink>
</template>
